import { jsxs, jsx } from 'react/jsx-runtime';
import { F as FooterViewMode } from './component-CyAstgZi.js';
import { L as LegalAgreements } from './component-CGswLQ0s.js';
import { L as LinkList } from './component-fhJDQPaF.js';
import { S as SocialMediaAppInfo } from './component-DATVhZle.js';
import { s as styleInject } from './style-inject.es-Bff-fD1R.js';

const LINK_KEY_CONTACT_US = 'contactUs';
const LINK_KEY_CAREERS = 'careers';
const LINK_KEY_REPORT_ERROR = 'reportError';

const linkList = [
    {
        href: 'https://www.sgcarmart.com/contact',
        key: LINK_KEY_CONTACT_US,
        text: 'Contact Us',
    },
    {
        href: 'https://www.sgcarmart.com/careers',
        key: LINK_KEY_CAREERS,
        text: 'Careers',
    },
    {
        href: 'https://m.sgcarmart.com/main/report_error.php',
        key: LINK_KEY_REPORT_ERROR,
        text: 'Report Error',
    },
];

var css_248z = ".SGCM_UIKIT_NEXT_Mobile_containerRoot_1iret_1 {\n  display: flex;\n  flex-direction: column;\n  padding: 14px 18px 29px;\n  background-color: whitesmoke;\n  row-gap: 15px;\n}\n\n.SGCM_UIKIT_NEXT_Mobile_containerSocialMediaAppLegalAgreements_1iret_9 {\n  display: flex;\n  flex-direction: column;\n  row-gap: 18px;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy5tb2R1bGUuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGFBQWE7RUFDYixzQkFBc0I7RUFDdEIsdUJBQXVCO0VBQ3ZCLDRCQUE0QjtFQUM1QixhQUFhO0FBQ2Y7O0FBRUE7RUFDRSxhQUFhO0VBQ2Isc0JBQXNCO0VBQ3RCLGFBQWE7QUFDZiIsImZpbGUiOiJzdHlsZXMubW9kdWxlLnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuY29udGFpbmVyUm9vdCB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIHBhZGRpbmc6IDE0cHggMThweCAyOXB4O1xuICBiYWNrZ3JvdW5kLWNvbG9yOiB3aGl0ZXNtb2tlO1xuICByb3ctZ2FwOiAxNXB4O1xufVxuXG4uY29udGFpbmVyU29jaWFsTWVkaWFBcHBMZWdhbEFncmVlbWVudHMge1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICByb3ctZ2FwOiAxOHB4O1xufSJdfQ== */";
var styles = {"containerRoot":"SGCM_UIKIT_NEXT_Mobile_containerRoot_1iret_1","containerSocialMediaAppLegalAgreements":"SGCM_UIKIT_NEXT_Mobile_containerSocialMediaAppLegalAgreements_1iret_9"};
styleInject(css_248z);

const isLinkKey = (value) => (typeof value === 'string' && [
    LINK_KEY_CONTACT_US,
    LINK_KEY_CAREERS,
    LINK_KEY_REPORT_ERROR,
].includes(value));

const PageFooter = ({ layout, linkDisableMap, allowViewDesktop, onViewDesktopClick, }) => (jsxs("footer", { className: styles.containerRoot, children: [jsx(LinkList, { data: linkList.filter(({ key }) => (isLinkKey(key) && !linkDisableMap?.[key])) }), jsxs("div", { className: styles.containerSocialMediaAppLegalAgreements, children: [jsx(SocialMediaAppInfo, {}), allowViewDesktop && (jsx(FooterViewMode, { layout: layout, onClick: onViewDesktopClick })), jsx(LegalAgreements, {})] })] }));

export { LINK_KEY_CAREERS as L, PageFooter as P, LINK_KEY_CONTACT_US as a, LINK_KEY_REPORT_ERROR as b, isLinkKey as i };
//# sourceMappingURL=component-BluO5D2e.js.map
